// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { PromptVersionOut } from './promptVersionOut.zod.ts';

export const PromptVersionListOut = zod.object({
  "versions": zod.array(PromptVersionOut)
});

export type PromptVersionListOut = zod.input<typeof PromptVersionListOut>;
export type PromptVersionListOutOutput = zod.output<typeof PromptVersionListOut>;
